module.exports = __webpack_public_path__ + "static/media/campaign-feature-3.f66fb967.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/campaign-feature-3.png
// module id = 612
// module chunks = 0